import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { isANumber, convertNumbersToProperFormat } from 'utils/number';
import styles from './styles.module.css';
import ListItem from './ListItem';
import {
  IProviderItemViewWithData,
  ITagView,
  ITEM_MIN_ORDER,
} from '../../store/providers/providerTypes';
import { ListColumnContainer, ListNavbar } from './styles';
import DragDropFileUpload from './DragDrop/DragDropFileUpload';
import i18n, { languageDirection } from '../../i18n';
import { ISearchTerm } from '../../containers/Profile/Panels/DocumentManager/DocumentManager';
import { IListItems } from './MultiList';

interface IProps {
  dadItem: any;
  loading: boolean;
  selected?: ISearchTerm | null;
  lastIndex?: boolean;
  listIndex: number;
  listItems: IListItems;
  onLoadItemsByDad: (id: number) => void;
  searching: boolean;
  lastList?: boolean;
  items?: { [key: number]: IProviderItemViewWithData };
  providerId: number;
}

interface IState {}

class List extends React.PureComponent<IProps, IState> {
  UNSAFE_componentWillMount() {
    if (this.props.dadItem) {
      this.props.onLoadItemsByDad(this.props.dadItem.id);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    const { dadItem, onLoadItemsByDad } = this.props;
    if (dadItem && nextProps.dadItem && nextProps.dadItem.id !== dadItem.id) {
      onLoadItemsByDad(nextProps.dadItem.id);
    }
  }

  render() {
    const {
      dadItem,
      loading,
      selected,
      lastList,
      listIndex,
      listItems,
      searching,
      providerId,
      items,
    } = this.props;
    const itemToDisplay = Object.values(listItems);
    const minOrder = itemToDisplay.reduce((min, el) => {
      if (
        typeof el.order !== 'number' ||
        isNaN(el.order) ||
        el.order <= ITEM_MIN_ORDER + 100
      ) {
        return min;
      }
      return Math.min(min, el.order);
    }, 1000000);

    let parentItem: IProviderItemViewWithData | null = null;
    if (this.props.items && dadItem) {
      parentItem = this.props.items[dadItem.id];
    }

    return (
      <ListColumnContainer>
        {dadItem ? (
          dadItem.getHeader()
        ) : (
          <ListNavbar>
            <div className="nav-wrapper">
              <ul
                style={{
                  float: languageDirection() === 'rtl' ? 'left' : 'right',
                  color: 'red',
                  maxWidth: 'calc(100% - 48px)',
                }}
              >
                <li style={{ height: '45px' }}>
                  <div>
                    <span className="text">
                      {
                        i18n.t('searchItemResult', {
                          ns: 'documentManager',
                        }) as string
                      }
                    </span>
                    {!searching && (
                      <span>
                        {
                          i18n.t('foundedItems', {
                            count:
                              i18n.language === 'en'
                                ? listItems.length
                                : convertNumbersToProperFormat(
                                    listItems.length
                                  ),
                            ns: 'documentManager',
                          }) as string
                        }
                      </span>
                    )}
                  </div>
                </li>
              </ul>
            </div>
          </ListNavbar>
        )}
        <Droppable droppableId={dadItem ? dadItem.id + '' : '-1'}>
          {(provided) => (
            <ul
              ref={provided.innerRef}
              style={{
                height: '100%',
                backgroundColor: 'var(--exact-white)',
                border: 'none',
                margin: '0',
                overflow: 'auto',
              }}
              className={`${styles.scrollBar} collection`}
            >
              {loading || searching ? (
                <li
                  className="collection-item avatar valign-wrapper grey-text"
                  style={{ padding: 'initial' }}
                >
                  <div className="full-width">
                    <div className="progress">
                      <div className="indeterminate" />
                    </div>
                  </div>
                </li>
              ) : itemToDisplay.length === 0 ? (
                <li
                  className="collection-item avatar valign-wrapper grey-text"
                  style={{ padding: 'initial' }}
                >
                  <div className="full-width">
                    <span
                      className="title center-align"
                      style={{ display: 'block' }}
                    >
                      {
                        i18n.t('folderIsEmpty', {
                          ns: 'documentManager',
                        }) as string
                      }
                    </span>
                  </div>
                </li>
              ) : (
                itemToDisplay.map((value: any, index) => {
                  let mandatoryTagIds: number[] = [];
                  if (
                    value.type === 'survey' &&
                    dadItem?.type === 'searchTag'
                  ) {
                    if (
                      items?.[dadItem.id].data.tags.find(
                        (tag: ITagView) => tag.text === 'conf_filterQuestions'
                      )
                    ) {
                      mandatoryTagIds = items?.[dadItem.id].data
                        .mandatoryTagIds as number[];
                    }
                  }
                  return (
                    <ListItem
                      key={value.id}
                      item={value}
                      index={index}
                      lastList={lastList}
                      selected={selected ? value.id === selected.value : null}
                      listIndex={listIndex}
                      expectedOrder={minOrder - 1}
                      isASearchList={!dadItem}
                      disableDrag={
                        !isANumber(value.id) ||
                        (dadItem ? dadItem.type === 'searchTag' : false)
                      }
                      isLink={
                        parentItem
                          ? Object.values(parentItem.data.itemLinks || {}).find(
                              (link: any) => link.destinationItemId === value.id
                            )
                          : false
                      }
                      mandatoryTagIds={mandatoryTagIds}
                    />
                  );
                })
              )}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
        {this.props.dadItem && (
          <DragDropFileUpload
            providerId={providerId}
            dataItemId={this.props.dadItem.id}
          ></DragDropFileUpload>
        )}
      </ListColumnContainer>
    );
  }
}

export default List;
